import { z } from "zod/v4";
import { disputeResponseSchema } from "../../schemas/finance/disputes";
import { fetchApi } from "../client/internal";

export const disputes = {
	// The finance service returns a bare array (`Json<Vec<DisputeResponse>>`), newest first.
	list: (clubId: string) => fetchApi(`/${clubId}/disputes`, z.array(disputeResponseSchema)),
};
